<template>
    <div>
        <breadcrumbs class="mb-3" />
        <v-tabs v-model="tab">
            <v-tab v-if="isTourOperator" value="direct_sales">{{ $t('direct_sales') }}</v-tab>
            <v-tab v-if="isTourOperator" value="B2C_settings">{{ $t('B2C_settings') }}</v-tab>
            <v-tab v-if="isTourOperator" value="group-of-contracts">{{ $t('group_of_contracts') }}</v-tab>
            <v-tab v-if="isTourOperator" value="TOConditions">{{ $t('TO_conditions') }}</v-tab>
            <v-tab v-if="isTO1" value="vouchers">{{ $t('vouchers') }}</v-tab>
            <v-tab v-if="isTO1 && isShowLoyalty" value="loyalty">{{ $t('sales_settings_tabs.loyalty') }}</v-tab>
            <v-tab v-if="isTO1 && isShowDiscountsAndPromo" value="discounts">
                {{ $t('discounts_and_promotions') }}
            </v-tab>
        </v-tabs>
        <v-tabs-window v-model="tab">
            <v-tabs-window-item value="direct_sales">
                <CompanyContract :company-id="companyId" contract-group-place="DIRECT_SALES" />
            </v-tabs-window-item>
            <v-tabs-window-item value="B2C_settings">
                <B2CSalesSettingsTable />
            </v-tabs-window-item>
            <v-tabs-window-item value="group-of-contracts">
                <GroupsOfContractsTable />
            </v-tabs-window-item>
            <v-tabs-window-item value="TOConditions">
                <TOConditionsForm />
            </v-tabs-window-item>
            <v-tabs-window-item value="vouchers">
                <VouchersForm />
            </v-tabs-window-item>
            <v-tabs-window-item value="loyalty">
                <LoyaltySalesSettingsTable />
            </v-tabs-window-item>
            <v-tabs-window-item value="discounts">
                <DiscountsAndPromotionsTable />
            </v-tabs-window-item>
        </v-tabs-window>
    </div>
</template>

<script setup lang="ts">
    import Breadcrumbs from '~src/components/Breadcrumbs.vue'

    const tab = ref()

    const isTO1 = computed(() => {
        return authStore.isTO1
    })

    const isTourOperator = computed(() => {
        return authStore.isTourOperator
    })

    const isShowDiscountsAndPromo = computed(() => {
        return runtimeStore.getCRMOption('asp.option.discounts.and.promotions')
    })

    const isShowLoyalty = computed(() => {
        return runtimeStore.getCRMOption('asp.option.show.loyalty')
    })

    const companyId = computed(() => {
        return authStore.company?.id
    })
</script>
